
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/webperformance/suzannelacy-birlikte",
      function () {
        return require("private-next-pages/webperformance/suzannelacy-birlikte.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/webperformance/suzannelacy-birlikte"])
      });
    }
  